import { NAV_TYPE } from './NAV_TYPE';
function getTimestamp() {
    var now = new Date();
    return 'x' + now.getYear() + now.getMonth() + now.getDate() + now.getHours() + now.getMinutes() + now.getSeconds();
}
/**
 * handles the logic what to do with the shop - either redirect to shop-web or show express payment
 *
 * @param userId the id of the user as String
 */
export default function (platform) {
    if (platform === void 0) { platform = 'classic'; }
    return new Promise(function (resolve, reject) {
        fetch("/gd/rest/paymentNavigationTarget?ts=" + getTimestamp() + "&platform=" + platform, {
            credentials: 'same-origin'
        })
            .then(function (e) { return e.json(); })
            .then(function (jsonResult) {
            if (jsonResult.target === 'EXPRESS_PAYMENT') {
                resolve({ navType: NAV_TYPE.SHOP_EXPRESS, bearer: jsonResult.bearerToken });
            }
            else if (jsonResult.target === 'SHOP_WEB') {
                // GO TO SHOP
                resolve({
                    navType: NAV_TYPE.SHOP_WEB,
                    location: jsonResult.url,
                    bearer: jsonResult.bearerToken
                });
            }
            else {
                reject({ errorCode: jsonResult.target, location: jsonResult.url });
            }
        })
            .catch(function (err) {
            reject(err);
        });
    });
}
//# sourceMappingURL=fetchNavigation.js.map